import { ActiveDirectoryUser } from "../ActiveDirectoryUser";

export class ResponsibilityUserObject {
    responsibilityUser: ActiveDirectoryUser;
}